export default "__VITE_PUBLIC_ASSET__5c02122e__"